import { useEffect, useState } from "react";
import { fmtNumber } from "../i18n";
import { textInnerStyle, formatMetricValue, metricRaw, applyTemplate, abbrevNum } from "../lib/elementStyle";

// Renders a live metric from YouTube (viewers/likes/views/subscribers/duration)
// or Twitch (viewers/followers), chosen via el.platform.
// Supports plain text with {n} placeholder and a goal progress bar.
export function DynamicElement({ el, ytData, twitchData }) {
  const data = el.platform === "twitch" ? twitchData : ytData;
  const isDuration = el.metrica === "duration";
  const [, tick] = useState(0);
  useEffect(() => {
    if (!isDuration) return;
    const id = setInterval(() => tick((n) => n + 1), 1000);
    return () => clearInterval(id);
  }, [isDuration]);

  let liveSeconds = 0;
  if (isDuration && data?.startTime && data?.isLive) {
    liveSeconds = Math.max(0, (Date.now() - new Date(data.startTime).getTime()) / 1000);
  }

  const valueStr = formatMetricValue(el, data, liveSeconds);
  const text = applyTemplate(el.template, valueStr);
  const s = el.estilo || {};

  if (el.modo === "barra" && !isDuration) {
    const raw = metricRaw(el, data);
    const meta = Number(el.meta) || 1;
    const pct = Math.max(0, Math.min(100, (raw / meta) * 100));
    const fs = s.fontSize || 48;
    const metaStr = el.formato === "abbrev" ? abbrevNum(meta) : fmtNumber(meta);
    return (
      <div style={{ width: "100%", height: "100%", display: "flex", flexDirection: "column", justifyContent: "center", gap: fs * 0.18, fontFamily: `'${s.fontFamily || "Manrope"}', sans-serif`, color: s.color || "#ffffff" }} data-testid="dynamic-bar">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline", fontSize: `${fs}px`, fontWeight: s.fontWeight || 800 }}>
          <span>{text}</span>
          <span style={{ opacity: 0.55, fontSize: `${fs * 0.6}px` }}>{metaStr}</span>
        </div>
        <div style={{ background: s.barBg || "#1a1a20", borderRadius: 999, height: Math.max(8, fs * 0.3), overflow: "hidden" }}>
          <div style={{ width: `${pct}%`, height: "100%", background: s.barColor || "#007AFF", borderRadius: 999, transition: "width 0.6s ease" }} />
        </div>
      </div>
    );
  }

  return <div style={textInnerStyle(s)} data-testid="dynamic-text">{text}</div>;
}
